
/* eslint-disable */
// /src/services/announcementsPublicService.js
import { db } from "./firebase";
import {
    collection, doc, getDoc, getDocs, query, orderBy, limit as qlimit,
} from "firebase/firestore";

const COL = collection(db, "announcements");

/** 목록 불러오기 (최신순) */
export async function listNotices({ limit = 50 } = {}) {
    const qy = query(COL, orderBy("publishedAt", "desc"), qlimit(limit));
    const snap = await getDocs(qy);
    const rows = [];
    snap.forEach(s => {
        const v = s.data() || {};
        rows.push({
            id: s.id,
            title: v.title || "",
            snippet: v.snippet || "",
            imageUrl: v.imageUrl || "",
            publishedAt: v.publishedAt?.toDate ? v.publishedAt.toDate() : (v.publishedAt ? new Date(v.publishedAt) : null),
        });
    });
    return rows;
}

/** 단건 상세 */
export async function getNotice(id) {
    if (!id) return null;
    const s = await getDoc(doc(COL, id));
    if (!s.exists()) return null;
    const v = s.data() || {};
    return {
        id: s.id,
        title: v.title || "",
        bodyHtml: v.bodyHtml || "",
        imageUrl: v.imageUrl || "",
        snippet: v.snippet || "",
        publishedAt: v.publishedAt?.toDate ? v.publishedAt.toDate() : (v.publishedAt ? new Date(v.publishedAt) : null),
    };
}
